import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/home'
import Scenes from '@/pages/scenes'
import Scene from '@/pages/scene'
import Panorama from '@/pages/panorama'
import Antiques from '@/pages/antiques'
import All from '@/pages/All'
import Detail from '@/pages/Detail'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: '首页',
      component: Home
    },{
      path: '/scenes',
      name: '场景漫游',
      component: Scenes,
      meta:['场景漫游']
    },{
      path: '/scene',
      name: '大场景',
      component: Scene,
      meta:['场景漫游','大场景']
    },{
      path: '/panorama',
      name: '全景风貌',
      component: Panorama,
      meta: ['全景风貌']
    },{
      path: '/antiques',
      name: '文物赏析',
      component: Antiques,
      meta: ['文物赏析']
    },{
      path: '/detail',
      name: '详情',
      component: Detail,
      meta: ['文物赏析','详情']
    },{
      path: '/all',
      name: '所有文物',
      component: All,
      meta: ['文物赏析']
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js